import React from "react";
import { getPublicUrl } from "../helpers/helper_functions";

import "./Footer.css";

const Footer = () => {
  const email = "seattlevegans@seattlegoesvegan.org";
  const subject = "Subject";
  const body = "Dear Seattle Vegans!";

  return (
    <div className="footer-main">
      <div className="footer-links">
        <ul>
          <li className="footer-section-title">Contact Us</li>
          <li>
            <a
              href={`mailto:${email}?subject=${
                encodeURIComponent(subject) || ""
              }&body=${encodeURIComponent(body) || ""}`}
            >
              Email us
            </a>
          </li>
        </ul>
        <ul className="desktop-only">
          <li className="footer-section-title">Vegan Resources</li>
          <li>
            <a href="https://linktr.ee/seattlegoesvegan">Seattle Vegan Guide</a>
          </li>

          <li>
            <a href="https://www.reddit.com/r/veganfitness/">
              Vegan Fitness Subreddit
            </a>
          </li>
          <li>
            <a href="https://www.reddit.com/r/vegan/">Vegan Subreddit</a>
          </li>
          <li>
            <a href="https://animalcharityevaluators.org/blog/vegan-diet/">
              Vegan Diet 101
            </a>
          </li>
          <li>
            <a href="https://how-to-go-vegan.peta.org/?utm_source=PETA%3A%3AGoogle&utm_medium=Ad&utm_campaign=0422%3A%3Aveg%3A%3APETA%3A%3AGoogle%3A%3ASEA-Vegan-Grant%3A%3A%3A%3Asearchad&gad_source=1&gclid=Cj0KCQjwpZWzBhC0ARIsACvjWRNcDXQ0hwpoYJabq79AZnBeC-1zKQTSQKsvJ9J3r8crOzy5C3MUT7MaAuTEEALw_wcB">
              How To Go Vegan
            </a>
          </li>
        </ul>
        <ul className="desktop-only">
          <li className="footer-section-title">Volunteering Options</li>
          <li>
            <a href="https://www.narn.org/">NARN</a>
          </li>
          <li>
            <a href="https://www.animalrightsinitiative.org/">
              Animal Rights Initiative
            </a>
          </li>
          <li>
            <a href="https://roosterhaus.org/help-us/volunteer/">
              Rooster Haus
            </a>
          </li>
          <li>
            <a href="https://www.pasadosafehaven.org/get-involved/volunteer/">
              Pasado's Safe Haven
            </a>
          </li>
          <li>
            <a href="www.pigspeace.org">Pig's Peace Sanctuary</a>
          </li>
        </ul>
        <ul>
          <li className="footer-section-title">Social Media</li>
          <li>
            <a href="https://discord.gg/pyg6T6eSXy">Discord</a>
          </li>
          <li>
            <a href="https://www.meetup.com/meetup-group-lwpygskl/">Meetups</a>
          </li>
          <li>
            <a href="https://www.instagram.com/seattlevegancommunity/">
              Instagram
            </a>
          </li>
        </ul>
      </div>
      <div className="footer-icons">
        <a href="https://discord.gg/pyg6T6eSXy">
          <img
            src={getPublicUrl("/assets/Footer/icons8-discord.svg")}
            alt={"discord"}
          />
        </a>
        <a href="https://www.instagram.com/seattlevegancommunity/">
          <img
            src={getPublicUrl("/assets/Footer/icons8-instagram.svg")}
            alt={"instagram"}
          />
        </a>
        <a href="https://www.meetup.com/meetup-group-lwpygskl/">
          <img
            src={getPublicUrl("/assets/Footer/icons8-meetup.svg")}
            alt={"meetups"}
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
